import { FC } from "react";
import { BotIcon, UserIcon } from "lucide-react";

import { clsxMerge } from "shared/lib/helpers/styles";
import { safeGetDate } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

import { EMAIL_SENDER_LABEL } from "@/modules/email-templates-sidebar/constants";
import { EmailHistoryItemType } from "@/modules/email-templates-sidebar/interfaces";

interface EmailHistoryDatePropsI extends PropsWithClassNameI {
  date: string;
  isSentByAI?: boolean;
  email_type: EmailHistoryItemType;
}

export const EmailHistoryDate: FC<EmailHistoryDatePropsI> = ({
  className,
  date,
  isSentByAI,
  email_type,
}) => {
  return (
    <div className={clsxMerge("h-fit w-[320px]", className)}>
      <div
        className={"mb-0.5 flex items-center gap-1 typography-body-4-medium"}
      >
        <p className={isSentByAI ? "text-gradient" : ""}>
          {EMAIL_SENDER_LABEL[email_type]}
        </p>

        <div
          className={clsxMerge(
            "flex size-[18px] items-center justify-center rounded-full border",
            isSentByAI ? "border-[#792799]" : "border-none"
          )}
        >
          {isSentByAI ? (
            <BotIcon className="w-3.5 text-[#982B7D]" />
          ) : (
            <UserIcon className="w-4" />
          )}
        </div>
      </div>

      <p className="typography-body-4">{safeGetDate(date)}</p>

      <div
        className={clsxMerge(
          "mt-2 h-[2px] w-full rounded-s-full bg-[#E5E7FF]",
          {
            "bg-gradient-to-r from-[#C935AB] to-[#714CC9]": isSentByAI,
          }
        )}
      />
    </div>
  );
};
